import { useWatch } from "react-hook-form";
import type { FieldValues, UseFormMethods } from "react-hook-form";
import { PAYMENT_TYPE_BILL } from "@constants";

interface IUsePortInParams<TFieldValues extends FieldValues = FieldValues> {
    formMethods: UseFormMethods<TFieldValues>;
    namePrefix?: string;
}

export const usePortIn = <TFieldValues extends FieldValues = FieldValues>(params: IUsePortInParams<TFieldValues>) => {
    const { formMethods, namePrefix } = params;
    const paymentTypeFieldName = namePrefix ? `${namePrefix}paymentType` : "paymentType";

    const paymentType = useWatch<string>({
        name: paymentTypeFieldName,
        control: formMethods.control,
        defaultValue: "",
    });
    const isPostPay = paymentType.includes(PAYMENT_TYPE_BILL);

    return {
        isPostPay,
    };
};
